import React from 'react'
import { format } from 'date-fns'
import { Month as LibMonth, MonthProps } from 'react-day-picker'
import { useTranslation } from 'react-i18next'

// data-calendar-month は、プラン詳細の ?month= でその月までスクロールするときの目印（date_range_picker_controller.js）
export const Month = ({ showHolidayCaption = true, ...props }: MonthProps & { showHolidayCaption?: boolean }) => {
  const { t } = useTranslation()

  return (
    <div className="month-container" data-calendar-month={format(props.calendarMonth.date, 'yyyy-MM')}>
      <LibMonth {...props} />
      {showHolidayCaption && (
        <div className="font-size-12 text-right mt-3 mr-3">
          <span className="text-red-500">*</span>
          {t('reservation_confirm.modal_booking.holiday_caption')}
        </div>
      )}
    </div>
  )
}
